// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Services/ConfigurationService.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { GlobalConfigurationEntryDto_IdentifierDtoSchema, GlobalConfigurationEntryDtoSchema, UserConfigurationEntryDto_IdentifierDtoSchema, UserConfigurationEntryDtoSchema } from "../Messages/Basic_pb";
import { file_Messages_Basic } from "../Messages/Basic_pb";
import { file_Options_MethodOptions } from "../Options/MethodOptions_pb";

/**
 * Describes the file Services/ConfigurationService.proto.
 */
export const file_Services_ConfigurationService: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations, file_Messages_Basic, file_Options_MethodOptions]);

/**
 * CRUD operations for application configuration.
 *
 * @generated from service ConfigurationService
 */
export const ConfigurationService: GenService<{
  /**
   * Fetch a global (tenant-wide) configuration value.
   *
   * @generated from rpc ConfigurationService.GetGlobalConfigurationEntry
   */
  getGlobalConfigurationEntry: {
    methodKind: "unary";
    input: typeof GlobalConfigurationEntryDto_IdentifierDtoSchema;
    output: typeof GlobalConfigurationEntryDtoSchema;
  },
  /**
   * Create or update a global (tenant-wide) configuration value.
   *
   * @generated from rpc ConfigurationService.SetGlobalConfigurationEntry
   */
  setGlobalConfigurationEntry: {
    methodKind: "unary";
    input: typeof GlobalConfigurationEntryDtoSchema;
    output: typeof GlobalConfigurationEntryDtoSchema;
  },
  /**
   * Delete a global (tenant-wide) configuration value.
   *
   * @generated from rpc ConfigurationService.DeleteGlobalConfigurationEntry
   */
  deleteGlobalConfigurationEntry: {
    methodKind: "unary";
    input: typeof GlobalConfigurationEntryDto_IdentifierDtoSchema;
    output: typeof GlobalConfigurationEntryDtoSchema;
  },
  /**
   * Fetch a configuration value belonging to a specific user.
   *
   * @generated from rpc ConfigurationService.GetUserConfigurationEntry
   */
  getUserConfigurationEntry: {
    methodKind: "unary";
    input: typeof UserConfigurationEntryDto_IdentifierDtoSchema;
    output: typeof UserConfigurationEntryDtoSchema;
  },
  /**
   * Create or update a configuration value belonging to a specific user.
   *
   * @generated from rpc ConfigurationService.SetUserConfigurationEntry
   */
  setUserConfigurationEntry: {
    methodKind: "unary";
    input: typeof UserConfigurationEntryDtoSchema;
    output: typeof UserConfigurationEntryDtoSchema;
  },
  /**
   * Delete a configuration value belonging to a specific user.
   *
   * @generated from rpc ConfigurationService.DeleteUserConfigurationEntry
   */
  deleteUserConfigurationEntry: {
    methodKind: "unary";
    input: typeof UserConfigurationEntryDto_IdentifierDtoSchema;
    output: typeof UserConfigurationEntryDtoSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_Services_ConfigurationService, 0);

